/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export function pathDropZoneMessage(name: string): string {
    return `<strong>Drag and drop</strong> a ${name} here `
            + `or select one on the connection column, or by the context menu on the pools column.`;
}

export function connectionsDropZoneMessage(name: string): string {
    return `<strong>Drag and drop</strong> a ${name} here `
            + `or select one by the context menu on the pools column.`;
}
